module.exports = __webpack_public_path__ + "img/55800.2284ddbd.jpg";